import { render } from "./CookieImg.vue?vue&type=template&id=57915ef8&lang=pug"
import script from "./CookieImg.vue?vue&type=script&lang=js"
export * from "./CookieImg.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sellerofhappiness/WORK/VUE/coral-cookie/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__